import React from "react";
import { ApprovedSign, InitialReviewSign, PendingSign, RejectedSign } from "../../Icons";
import { CompletedCheckIcon } from "../../../crypto/icons";

const StatusIcon = ({ status, crypto = false, className = "" }) => {
  // Normalize string for case-insensitive matching
  const normalizedStatus = status?.toUpperCase()?.trim();

  // Return bare icons for standard (non-crypto) views
  if (!crypto) {
    switch (normalizedStatus) {
      case "INITIATED":
      case "INITIAL REVIEW":
        return <InitialReviewSign className={className} />;
      case "PENDING":
        return <PendingSign className={className} />;
      case "APPROVED":
        return <ApprovedSign className={className} />;
      case "REJECTED":
        return <RejectedSign className={`w-3 h-3 ${className}`} />;
      default:
        return null;
    }
  }

  // Crypto specific circular badges with status colors
  switch (normalizedStatus) {
    case "APPROVED":
      return (
        <div className={`flex items-center justify-center size-5 rounded-full bg-[#4ab932]/20 text-[#4ab932] ${className}`}>
          <CompletedCheckIcon />
        </div>
      );

    case "PENDING":
      return (
        <div className={`flex items-center justify-center size-5 rounded-full bg-amber-500/20 text-amber-500 ${className}`}>
          <PendingSign />
        </div>
      );

    case "INITIATED":
    case "INITIAL REVIEW":
      return (
        <div className={`flex items-center justify-center size-5 rounded-full bg-blue-500/20 text-blue-500 ${className}`}>
          <InitialReviewSign />
        </div>
      );

    case "REJECTED":
      return (
        <div className={`flex items-center justify-center size-5 rounded-full bg-red-500/20 text-red-500 ${className}`}>
          <RejectedSign className="size-3.5" />
        </div>
      );

    default:
      return null;
  }
};

export default StatusIcon;
